/**
 * @file    lineChartData
 * @scope   SHARED
 * @summary Extracts line-chart series data from the legacy table (react-data-table columns).
 * @consumes DynamicTable/common/utils/lineChartOptionsBuilder
 * @produces getLegacyLineChartData
 * @sideEffects None.
 */
import { LineChartData, TableState } from 'components/DynamicTable/common/types';
import {
  extractTextFromNode,
  getColumnFieldKey,
  getPercentageFlag,
} from 'components/DynamicTable/common/utils/lineChartOptionsBuilder';

const EMPTY: LineChartData = { xData: [], yData: [], percentageFlags: [] };

export const getLegacyLineChartData = (table?: TableState): LineChartData => {
  if (!table || !table.data || !table.columns || !table.columns[0]?.sortField) return EMPTY;

  const dataColumns = table.columns.slice(1);
  const firstRow = table.data[0];

  return {
    xData: dataColumns.map((col, idx) => {
      const label = extractTextFromNode(col?.name).trim();
      return label !== '' ? label : `Metric ${idx + 1}`;
    }),
    percentageFlags: dataColumns.map((col) =>
      getPercentageFlag(table.rawData, getColumnFieldKey(col), firstRow)
    ),
    yData: table.data.map((row) =>
      dataColumns.map((col) => {
        const fieldKey = getColumnFieldKey(col);
        if (!fieldKey) return null;
        const val = row[fieldKey];
        // QUIRK: a `null` cell throws here ('value' in null); kept as in the original.
        return typeof val === 'object' && 'value' in val ? val.value : val;
      })
    ),
  };
};
